import comp from "./StandardsView";
export default comp;
